import { convertDatePtBr, convertDatePtBrHs } from 'utils/dateFormatter';
import {
  cpfMaskView,
  telefoneMask,
  cnpjMaskView,
  inscricaoEstadualMaskView,
  inscricaoMunicipalMaskView,
  cepMaskView,
} from 'utils/masks';
import { removeTagsHtmlDeTexto } from 'utils/stringFormatter';
import { getTipoPerfil } from 'utils/funcaoPadrao';
import { getEnv } from 'config/enviroment';

export const _getStringHtmlInput = (label, descricao) => {
  let html = '';
  html += `<div class="containerLabel">`;
  html += `<p class="label">${label}</p>`;
  html += `<p class="descricao">${descricao || ''}</p>`;
  html += `</div>`;
  return html;
};

export const _getStringHtmlJustificativa = justificativaCompleta => {
  const { justificativa, dataInsercao, atendente } = justificativaCompleta;
  const autor = atendente?.apelido || 'Contribuinte';

  let html = '';
  html += `<div class="containerJustificativa">`;
  html += `<p class="tituloJustificativa">${autor} ${dataInsercao ? '- ' + convertDatePtBrHs(dataInsercao) : ''}</p>`;
  html += `<p class="descricao">${removeTagsHtmlDeTexto(justificativa)}</p>`;
  html += `</div>`;
  return html;
};

export const _getStringHtmlTitulo = user => {
  const userName = user?.name_representative;
  const userDocument = user?.cpf_cnpj_representative;
  const userProfile = getTipoPerfil(user?.profile);

  const titleDefault = `<head><title>Relatório FAS</title></head>`;
  const titleUser = `<head><title>Relatório FAS - Por: ${userName} - ${userDocument} - ${userProfile}</title></head>`;

  return !user ? titleDefault : titleUser;
};

export const _getStringHtmlInfo = user => {
  const userName = user?.name_representative;
  const userDocument = user?.cpf_cnpj_representative;
  const userProfile = getTipoPerfil(user?.profile);

  let htmlReturn = `<p class="info">Data da emissão: ${convertDatePtBrHs(new Date())}</p>`;
  if (user) {
    htmlReturn += `<p class="info">Gerado por: ${userName} - ${userDocument} - ${userProfile}</p>`;
  }

  htmlReturn += `<p class="info">Versão do FAS: ${getEnv()?.VERSAO || 'Error'}</p>`;
  return htmlReturn;
};

export const createHtmlComprovante = (dadosApi, user) => {
  const pessoa = dadosApi?.formularioPessoa?.pessoa;
  const nomesArquivos = dadosApi?.arquivos?.map(x => x.nomeArquivo);
  const justificativa = dadosApi?.formularioJustificativas;

  let style = '<style>';
  style += '.titulo {color: #0078bb; font-weight: 600; text-align: center; font-size: 18pt; margin: 0; }';
  style += '.subtitulo {text-align: center; font-size: 9pt; margin: 0; }';
  style +=
    '.card {width: 95%;margin: auto; margin-top: 5px; padding: 20px;background: rgba(255, 255, 255, 0.3);backdrop-filter: blur(10px);  border-radius: 10px; border: 1px solid rgba(255, 255, 255, 0.18);}';
  style += '.cardContainer {display: flex;flex-wrap: wrap;justify-content: space-between;}';
  style += '.descricao {margin: 0; font-size: 9pt;}';
  style += '.label {margin: 0; font-weight: 600;}';
  style += '.containerLabel {margin: 7px 10px;padding: 3px;min-width: 28%;}';
  style += '.tituloJustificativa { font-size: 12pt;font-weight: bold;}';
  style += '.info { margin: 0;font-size: 8pt;opacity: 50%; text-align: end; }';
  style += 'body { font: 20px Calibri; }';
  style += '</style>';

  let windowContent = '<!DOCTYPE html>';
  windowContent += style;
  windowContent += '<html>';
  windowContent += _getStringHtmlTitulo(user);

  windowContent += '<body>';
  windowContent += `<p class="titulo">Comprovante do Requerimento ${dadosApi?.localizador}</p>`;
  windowContent += `<p class="subtitulo">PREFEITURA MUNICIPAL DO SALVADOR - SECRETARIA DA FAZENDA</p>`;

  windowContent += `<div class="card">`;
  windowContent += `Pessoa Fisica`;
  windowContent += `<div class="cardContainer">`;
  windowContent += _getStringHtmlInput('Nome', pessoa?.nome);
  windowContent += _getStringHtmlInput('Nome Social', pessoa?.nomeSocial);
  windowContent += _getStringHtmlInput('CPF', cpfMaskView(pessoa?.cpf));
  windowContent += _getStringHtmlInput('Data de Nascimento', convertDatePtBr(pessoa?.dataNascimento));
  windowContent += _getStringHtmlInput('Sexo', pessoa?.sexo?.descricao);
  windowContent += _getStringHtmlInput('E-mail', pessoa?.email);
  windowContent += _getStringHtmlInput('Telefone', telefoneMask(pessoa?.telefone));
  windowContent += _getStringHtmlInput('Escolaridade', pessoa?.escolaridade?.descricao);
  windowContent += _getStringHtmlInput('Profissão', pessoa?.profissao?.descricao);
  windowContent += `</div>`;
  windowContent += `</div>`;

  windowContent += `<div class="card">`;
  windowContent += `Pessoa Juridica`;
  windowContent += `<div class="cardContainer">`;
  windowContent += _getStringHtmlInput('Cargo do Representante', pessoa?.cargoRepresentante);
  windowContent += _getStringHtmlInput('Razão Social', pessoa?.razaoSocial);
  windowContent += _getStringHtmlInput('CNPJ', cnpjMaskView(pessoa?.cnpj));
  windowContent += _getStringHtmlInput('Inscrição Estadual', inscricaoEstadualMaskView(pessoa?.inscricaoEstadual));
  windowContent += _getStringHtmlInput('Inscrição Municipal', inscricaoMunicipalMaskView(pessoa?.inscricaoMunicipal));
  windowContent += _getStringHtmlInput('Tipo de Instituição', pessoa?.instituicao?.nomeInstituicao);
  windowContent += _getStringHtmlInput('Área de Atuação', pessoa?.areaAtuacao?.atuacao);
  windowContent += `</div>`;
  windowContent += `</div>`;

  windowContent += `<div class="card">`;
  windowContent += `Endereço`;
  windowContent += `<div class="cardContainer">`;
  windowContent += _getStringHtmlInput('CEP', cepMaskView(pessoa?.endereco?.cep));
  windowContent += _getStringHtmlInput('Logradouro', pessoa?.endereco?.logradouro);
  windowContent += _getStringHtmlInput('Complemento', pessoa?.endereco?.complemento);
  windowContent += _getStringHtmlInput('Número', pessoa?.endereco?.numero);
  windowContent += _getStringHtmlInput('Bairro', pessoa?.endereco?.bairro);
  windowContent += _getStringHtmlInput('Cidade', pessoa?.endereco?.cidade);
  windowContent += _getStringHtmlInput('Estado', pessoa?.endereco?.estado);
  windowContent += _getStringHtmlInput('País', pessoa?.endereco?.pais);
  windowContent += `</div>`;
  windowContent += `</div>`;

  windowContent += `<div class="card">`;
  windowContent += `Serviço: ${dadosApi?.assunto?.descricao}`;
  windowContent += `</div>`;

  windowContent += `<div class="card">`;
  windowContent += `Documentos Necessários: ${dadosApi?.solicitacao?.documentos || ''}`;
  windowContent += `</div>`;

  windowContent += `<div class="card">`;
  windowContent += `Anexos: ${nomesArquivos?.toString().replace(',', ' - ')}`;
  windowContent += `</div>`;

  windowContent += `<p class="titulo">Histórico de respostas ${dadosApi?.localizador}</p>`;

  justificativa?.forEach(x => {
    windowContent += _getStringHtmlJustificativa(x);
  });

  windowContent += _getStringHtmlInfo(user);

  windowContent += '</body>';
  windowContent += '</html>';
  return windowContent;
};
